import { render, staticRenderFns } from "./schoolConsuReport.vue?vue&type=template&id=1ab1f1ba"
import script from "./schoolConsuReport.vue?vue&type=script&lang=js"
export * from "./schoolConsuReport.vue?vue&type=script&lang=js"
import style0 from "./schoolConsuReport.vue?vue&type=style&index=0&id=1ab1f1ba&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports